import { render, staticRenderFns } from "./ForgotPassword2.vue?vue&type=template&id=23fc16b9&scoped=true&"
import script from "./ForgotPassword2.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword2.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword2.vue?vue&type=style&index=0&id=23fc16b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc16b9",
  null
  
)

export default component.exports